import type { InjectionKey, UnwrapRef } from 'vue'
// import type {
//   RuleItem,
//   ValidateError,
//   ValidateFieldsError,
// } from 'async-validator'
import type { ComponentSize } from '@bigin/constants'
import type {
  FormItemProps,
  FormLabelWidthContext,
} from '@bigin/components/form'
// import type { Arrayable } from '@bigin/utils'

// export interface FormItemRule extends RuleItem {
//   trigger?: Arrayable<string>
// }
// export type FormRules = Partial<Record<string, Arrayable<FormItemRule>>>

// export type FormValidationResult = Promise<boolean>
// export type FormValidateCallback = (
//   isValid: boolean,
//   invalidFields?: ValidateFieldsError
// ) => void
// export interface FormValidateFailure {
//   errors: ValidateError[] | null
//   fields: ValidateFieldsError
// }

export type FormContext = UnwrapRef<FormLabelWidthContext>

export interface FormItemContext extends FormItemProps {
  $el: HTMLDivElement | undefined
  size: ComponentSize
  setFocused: (value: boolean) => void
}

export const formContextKey: InjectionKey<FormContext> =
  Symbol('formContextKey')
export const formItemContextKey: InjectionKey<FormItemContext> =
  Symbol('formItemContextKey')
